<script>
  export let token;
  export let ligament;
  export let refreshCallback = () => {};
</script>

<span class="date-label">Base currency</span>
{#if ligament === 'WLIS/NEAR'}
  <select class="form-select" bind:value={token} on:change={refreshCallback}>
    <option value="0" selected>LIS</option>
    <option value="1">NEAR</option>
  </select>
{:else if ligament === 'WLIS/USDT'}
  <select class="form-select" bind:value={token} on:change={refreshCallback}>
    <option value="0" selected>LIS</option>
    <option value="1">USDT</option>
  </select>
{:else if ligament === 'NEAR/USDT'}
  <select class="form-select" bind:value={token} on:change={refreshCallback}>
    <option value="0" selected>NEAR</option>
    <option value="1">USDT</option>
  </select>
{:else if ligament === 'MATIC/USDT'}
  <select class="form-select" bind:value={token} on:change={refreshCallback}>
    <option value="0" selected>MATIC</option>
    <option value="1">USDT</option>
  </select>
{:else if ligament === 'WLIS/MATIC'}
  <select class="form-select" bind:value={token} on:change={refreshCallback}>
    <option value="0" selected>WLIS</option>
    <option value="1">MATIC</option>
  </select>
{/if}